class MatrikkelSearchEvents {
    static SelectAdresse = "SELECT_ADRESSE"
    static SelectBygg = "SELECT_BYGG"
    static SelectEier = "SELECT_EIER"
    static SelectMatrikkelenhet = "SELECT_MATRIKKELENHET"

    static ZoomToObject ="ZOOM_TO_OBJECT"
    static ShowObject ="SHOW_OBJECT"

    static ShowAdresse = "SHOW_ADRESSE"
    static ShowAnleggsprojeksjonsflate = "SHOW_ANLEGGSPROJEKSJONSFLATE"
    static ShowBruksenhet = "SHOW_BRUKSENHET"
    static ShowBygg = "SHOW_BYGG"
    static ShowFestegrunn = "SHOW_FESTEGRUNN"
    static ShowMatrikkelenhet = "SHOW_MATRIKKELENHET"
    static ShowSeksjon = "SHOW_SEKSJON"
    static ShowTeig = "SHOW_TEIG"
    static ShowStedsnavn = "SHOW_STEDSNAVN"

    static ExpandGrunnbok = "EXPAND_GRUNNBOK"
    static ExpandGrunnbokEnd = "EXPAND_GRUNNBOK_END"

    static ResultChanged = "RESULT_CHANGED"
    static ResetMatrikkelSearch = "RESET_MATRIKKEL_SEARCH"
    static ShowSearchTinglystDokument = "SHOW_SEARCH_TINGLYST_DOKUMENT"
    static HideSearchTinglystDokument = "HIDE_SEARCH_TINGLYST_DOKUMENT"
    static ShowUtskriftBestilling = "SHOW_UTSKRIFT_BESTILLING"
    static HideUtskriftBestilling = "HIDE_UTSKRIFT_BESTILLING"

}

export default MatrikkelSearchEvents